module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-my-100"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row center"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "portal-error-text"
  }, [_vm._v("\n                              An unexpected error has occurred. Please try again in a few minutes or "), _c('a', {
    staticClass: "portal-error-text",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.ToggleHelpForm()
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(".\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-px-30 g-mx-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.Route('Home')
      }
    }
  }, [_vm._v("Home")])])])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e3b35d64", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3b35d64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ErrorPage.vue
// module id = 559
// module chunks = 3